import { Component } from '@angular/core';

@Component({
  selector: 'wl-background-pattern',
  templateUrl: './background-pattern.component.html',
  standalone: true,
})
export class BackgroundPatternComponent {}
